import isString from 'lodash/isString'

export const getEnumValue = (enumValue: any): string => {
  return isString(enumValue) && enumValue.includes(':')
    ? enumValue.split(':')[1]
    : enumValue
}
